import { graphql, useStaticQuery } from "gatsby";

type ModalFormDisabled = {
    tituloPrincipal: string;
    descripcion: {
        raw: string;
    };
    tituloBoton: string;
    redireccionBoton: string;
    contentful_id: string;
    formularioCeidActivo: boolean;
    idFormulario: number;
};

function useDisableFormData() {
    const { fiftymore } = useStaticQuery<
        Record<string, ModalFormDisabled | undefined>
    >(graphql`
        query DisabledFormsQuery {
            fiftymore: contentfulContactenos(
                contentful_id: { eq: "3pXxwjfBCYbUrZvvesxcYm" }
            ) {
                tituloPrincipal
                descripcion {
                    raw
                }
                tituloBoton
                redireccionBoton
                contentful_id
                formularioCeidActivo
                idFormulario
            }
        }
    `);
    return {
        fiftymore,
    };
}

export default useDisableFormData;
